<template>
  <String class="string--red-white" :strLength="this.strLength">
    <Red :brightness="channelOneBrightness"/>
    <White :brightness="channelTwoBrightness"/>
  </String>
</template>

<script>
  import String from './String';
  import Red from '../Lights/Red';
  import White from '../Lights/White';

  export default {
    name: 'RedWhiteString',
    components: {
      String,
      Red,
      White
    },
    props: {
      channelOneBrightness: Number,
      channelTwoBrightness: Number,
      strLength: {
        type: Number,
        default: 20
      }
    }
  };
</script>

<style>

</style>
